export default () => ({
    hotel : {}
})